import {Layout, Text, GraphAggregates, usePageContext} from '~/components'
import {date} from '@eitje/utils'
import {useAggregatesTaxonomy} from './use_aggregates_taxonomy'

export const AggregatesHeader = () => {
	const {selectedSeriesPointIndex, graphs: graphSeries} = usePageContext()
	const aggregates = useAggregatesTaxonomy()

	const xLabels = graphSeries[0].data._map('x')
	const activeXLabel = xLabels[selectedSeriesPointIndex]

	return (
		<Layout width="full" gap={16}>
			<Text center bold fontSize={24} color="dark-grey">
				{date(activeXLabel).format("MMM [']YY")}
			</Text>
			<GraphAggregates layoutProps={{grow: true}} metrics={graphSeries} aggregates={aggregates} />
		</Layout>
	)
}
